var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditblueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60003 4.1L9.20002 2.5L12 5.30001L10.4 6.89999M7.60003 4.1L2.16568 9.53433C2.0596 9.6404 2 9.78431 2 9.93433V12.5H4.56569C4.71572 12.5 4.8596 12.4404 4.96569 12.3343L10.4 6.89999M7.60003 4.1L10.4 6.89999",
    stroke: "#4E4FA9",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditblueIcon);
export default __webpack_public_path__ + "static/media/editblue-icon.076e6dbf98297ad207422756a1b93ffb.svg";
export { ForwardRef as ReactComponent };